<template>
  <div class="toast">
    <div
      :class="colour"
    >
      <span>
        <span
          v-if="icon"
          class="hidden md:inline-block"
        >
          <FontAwesomeIcon :icon="icon" />
        </span>

        <span class="fs-6 ms-2">
          {{ message }}
        </span>
      </span>

      <button
        type="button"
        @click="$emit('dismissed')"
      >
        <FontAwesomeIcon
          :icon="faCircleXmark"
          class=""
        />
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleXmark, faCircleCheck, faInfoCircle, faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

const emit = defineEmits(['dismissed']);

const props = defineProps({
  message: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: null,
  },
  duration: {
    type: Number,
    default: 5000,
  },
});

// Mapping of Bootstrap alert colors to Font Awesome icons
const iconMapping = {
  success: faCircleCheck,
  info: faInfoCircle,
  warning: faCircleExclamation,
  danger: faCircleXmark,
};

const colourMapping = {
  success: 'toast-success',
  info: 'toast-info',
  warning: 'toast-warning',
  danger: 'toast-danger',
};

const colour = computed(() => colourMapping[props.type] || '');
const icon = computed(() => iconMapping[props.type] || '');

let autoCloseTimer = null;

const startAutoCloseTimer = () => {
  autoCloseTimer = setTimeout(() => {
    emit('dismissed');
  }, props.duration);
};

onMounted(() => {
  startAutoCloseTimer();
});

onBeforeUnmount(() => {
  if (autoCloseTimer) {
    clearTimeout(autoCloseTimer);
  }
});

</script>
